export default __webpack_public_path__ + "static/media/rider.829e42f5.svg";